// 越南語
export default {
    dialog: {
        msgShow: "Thông báo",
        buttonOk: 'ĐƯỢC RỒI',
        buttonCancel: 'Hủy bỏ',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Đóng'
    },
    employeeNumber: 'ID kỹ thuật viên',
    pleaseEnterEmployeeNumber: 'Nhập ID kỹ thuật viên',
    password: 'Mật khẩu',
    pleaseEnterPassword: 'Nhập mật khẩu',
    login: 'Đăng nhập',
    required: 'Yêu cầu',
    synchronize: 'Đồng bộ hóa.',
    salesOrder: 'Dịch vụ báo cáo',
    pleaseEnterHome: 'Nhập tên khách hàng và báo cáo dịch vụ',
    searchFilter: 'Tìm kiếm & Lọc',
    machineSpecifications: 'Model & Thông số kỹ thuật',
    processingStatus: 'Tình hình',
    processing: 'Trong tiến trình',
    finish: 'Hoàn thành',
    waitCountermeasures: 'Chờ sửa chữa',
    reset: 'Trở lại',
    submit: 'Đã gửi',
    muMachineInvestigation: 'Sử dụng máy móc',
    logout: 'Đăng xuất',
    searchDate: 'Ngày tháng năm',
    time: 'Thời gian làm mấy ngày',
    basicInformation: 'Dữ liệu khách hàng',
    addSalesOrder: 'Thêm báo cáo dịch vụ',
    save: 'Lưu lại',
    date: 'Ngày',
    pleaseSelectDate: 'Chọn ngày',
    travelNumber: 'Tệp báo cáo dịch vụ',
    pleaseEnterTravelNumber: 'Nhập tệp Báo cáo dịch vụ số.',
    customerCode: 'Mã khách hàng',
    pleaseEnterCustomerCode: 'Nhập mã khách hàng',
    customerName: 'Tên khách hàng',
    pleaseEnterCustomerName: 'Nhập tên khách hàng',
    country: 'Khu vực đất nước',
    pleaseEnterCountry: 'Nhập khu vực quốc gia',
    customerAddress: 'Địa chỉ của khách hàng',
    pleaseEnterAddress: 'Nhập địa chỉ khách hàng',
    customerContact: 'Người liên hệ khách hàng',
    pleaseEnterContact: 'Nhập người liên hệ của khách hàng',
    salesRepresentative: 'Đại diện bán hàng',
    pleaseEnterSalesRepresentative: 'Vui lòng nhập đại diện bán hàng',
    hint: 'Chú ý',
    createDate: 'Ngày thành lập',
    salesOrderNumber: 'Tệp báo cáo số',
    customerSatisfaction: 'Sự hài lòng của khách hàng',
    maintenancePersonnel: 'Kỹ thuật viên',
    maintenanceTime: 'Thời gian phục vụ',
    customerConfirmation: 'Khách hàng xác nhận',
    copy: 'Sao chép',
    delete: 'Xóa bỏ',
    recordTime: 'Ghi lại thời gian',
    machineNumber: 'Số máy',
    copyToSalesOrder: 'Sao chép trong',
    copyTo: 'Sao chép vào',
    selectSalesOrderNumber: 'Chọn tệp báo cáo dịch vụ',
    pleaseEnterSalesOrderNumber: 'Nhập tệp báo cáo dịch vụ số.',
    latitudeAndLongitude: 'Kinh độ vĩ độ',
    startMaintenance: 'Bắt đầu dịch vụ',
    endMaintenance: 'Kết thúc dịch vụ',
    newMachine: 'Báo cáo cài đặt',
    maintenance: 'Sửa chữa máy móc',
    addMachineServiceOrder: 'Thêm tệp báo cáo dịch vụ máy',
    selectType: 'Lựa chọn máy mới hay máy cũ',
    generalMaintenance: 'Sửa chữa máy móc',
    oilEducationTraining: 'OIL đào tạo kỹ thuật',
    pleaseEnterMachineNumber: 'Nhập số máy',
    manufacturingDate: 'Ngày sản xuất',
    pleaseSelectManufacturingDate: 'Chọn ngày sản xuất',
    maintenanceWarranty: 'Dịch vụ bảo hành (một năm)',
    underWarranty: 'Dịch vụ trong thời gian bảo hành',
    warrantyExpired: 'Hết hạn bảo hiểm',
    confirm: 'ĐƯỢC RỒI',
    cancel: 'Hủy bỏ',
    addMaintenancePersonnel: 'Nhập thêm tên kỹ thuật viên',
    maintenanceTimeTotal: 'Tổng thời gian phục vụ',
    day: 'Ngày',
    hour: 'Giờ',
    enterFactory: 'Bắt đầu dịch vụ',
    pleaseSelectEnterFactory: 'Chọn bắt đầu dịch vụ',
    longitude: 'Kinh độ',
    pleaseEnterLongitude: 'Vui lòng nhập kinh độ',
    latitude: 'Vĩ độ',
    pleaseEnterLatitude: 'Vui lòng nhập vĩ độ',
    leaveFactory: 'Kết thúc dịch vụ',
    pleaseSelectLeaveFactory: 'Vui lòng chọn dịch vụ hoàn tất',
    duration: 'Thời gian phục vụ',
    pleaseEnter: 'Vui lòng nhập',
    selectTime: 'Chọn ngày và giờ chọn',
    selectSatisfaction: 'Sự hài lòng của khách hàng',
    verySatisfied: 'Rất hài lòng',
    satisfied: 'Thỏa mãn',
    ordinary: 'Bình thường',
    dissatisfied: 'bất mãn',
    veryDissatisfied: 'Rất bất mãn',
    opinionReply: 'Ý kiến của khách hàng',
    takePhoto: 'Chụp ảnh',
    uploadFile: 'Cập nhật dử liệu',
    audio: 'Tập tin âm thanh',
    video: 'Tập tin video',
    electronicSignature: 'Chữ ký của khách hàng',
    signatureDate: 'Ngày ký',
    clear: 'Xóa bỏ',
    machineInformation: 'Dữ liệu máy',
    machineFunction: 'Kiểm tra máy',
    organizationArrangement: 'Cấu trúc & Hoa văn',
    spareParts: 'Linh kiện máy',
    operationProcedure: 'Hồ sơ kiểm tra',
    problemHandling: 'Vấn đề sửa chữa',
    trainee: 'Thực tập sinh',
    coursePlan: 'kế hoạch khóa học',
    courseSchedule: 'Lịch học',
    inputVoltageAndCurrent: 'Nhập điện áp/ampe',
    lowSpeed: 'Tốc độ chậm',
    highSpeed: 'Tốc độ cao',
    accelerationDecelerationSlope: 'Tấc độ nhanh chậm 9.9/0.5 9.9/1.2',
    acceleration: 'Acc. con dốc',
    deceleration: 'Dec.dung may tai cho',
    clothRoller: 'Quấn vải',
    left: 'Bên trái',
    center: 'Ở giữa',
    right: 'Phải',
    yarnFeedingTeeth: 'Bánh răng/dia va bao quan',
    saddleRingDistance: 'Quận. vòng & khung giữ cam',
    yarnNozzleNumber: 'Vận chuyển sợi',
    height: 'Chiều cao',
    spacing: 'Khoảng cách',
    warpYarnInfo: 'Vải xám',
    inch: 'Inch',
    cm: 'centimét',
    timeSequence: 'Tâm trái hay phải',
    needle: 'kim tiêm',
    yarnSpecification: 'Đặc điểm kỹ thuật sợi',
    yarn: 'Sợi',
    serialNumber: 'Số máy khác',
    technician: 'Kỹ thuật viên',
    series: 'Dòng vải',
    fabricType: 'Các loại vải',
    productFeatures: 'Tính năng sản phẩm',
    inputVoltage: 'Nhập điện áp',
    inputCurrent: 'Nhập ampe',
    electronicWindingTensionUpper: 'Điện. ampe lăn (trên)',
    electronicWindingTensionLower: 'Điện. ampe lăn (thấp hơn)',
    mechanicalType: 'Máy móc. bánh răng lăn',
    lowerNeedleDistanceToSeatRing: 'Dis. vòng giữ xi lanh và cam',
    upperNeedleDistanceToSeatRing: 'Dis. vòng giữ quay số và cam',
    upperNeedleDistanceToLowerNeedleNozzle: 'Khoảng cách quay số & xi lanh gõ trên cạnh',
    selectorNeedleRingDistanceToTakeUpPlate: 'Dis. giữa vòng và khung truyền động',
    seatRingDistanceToTakeUpPlate: 'Dis. giữa vòng giữ cam và khung',
    machineSpeed: 'vòng/phút',
    inverterFrequency: 'Biến tần HZ',
    yarnCount: 'CPI',
    gramsPerSquareMeter: 'GSM',
    yardsPerPound: 'G/YD',
    customerYarnWidth: 'Chiều rộng',
    customerSpecifiedYarnLength: 'Chiều dài mũi khâu chỉ định',
    newCustomerPackageTiming: 'Thời gian chìm',
    doubleSidedCuttingTiming: 'Quay số thời gian cam',
    nozzleTiming: 'Thời gian vận chuyển sợi',
    yarnCode: 'Mã sợi',
    yarnType: 'Thông số sợi.',
    color: 'Màu sắc',
    yarnSize: 'Số lượng sợi',
    fiberCount: 'dây tóc',
    innerFiber: 'Đổ vào',
    outerFiber: 'Chồng chất ra',
    flatness: 'Độ bằng',
    roundness: 'Độ tròn',
    windPressure: 'Áp suất thổi gió',
    appearance: 'Vẻ bề ngoài',
    machineLevel: 'Độ phẳng của khung máy',
    trident: 'Độ cân bằng và độ tròn của mặt số',
    highLegWinder: 'Chân cao đưa lên',
    fabricSlitting: 'Chiều rộng mở chiếm',
    inverterCurrent: 'Ampe biến tần',
    machineFunctionFrame: 'Sợi MPF & Ring & Creels',
    inchStart: 'Công tắc chạy bộ, khởi động và dừng.',
    firstSecondSpeed: 'Chức năng chuyển đổi tốc độ, đèn và quạt.',
    firstSecondSpeed2: 'Chức năng cài đặt tốc độ.',
    controllerOtherFunctions: 'Chức năng khác của bộ điều khiển',
    electricalBoxSignals: 'Tín hiệu & Cảm biến',
    fanDustRemovalAction: 'Hoạt động của quạt',
    oilSprayerAction: 'Vận hành tàu dầu',
    airBlowerSystemAction: 'Áp suất không khí và vận hành',
    windingAction: 'Hãy lên sys. hoạt động',
    machineControllerOperationTutorial: 'Đào tạo vận hành bảng điều khiển',
    machineOperationTutorial: 'Đào tạo vận hành M/C',
    other: 'Người khác',
    descriptionAndAttachment: 'Thuyết minh giải quyết',
    upperNeedleArrangement: 'Thứ tự kim mâm trên',
    upperKnifeArrangement: 'dao cắt mâm trên',
    lowerNeedleArrangement: 'Thứ tự kim mâm dưới',
    lowerNeedleArrangementShort: 'Thứ tự kim mâm dưới',
    lowerKnifeArrangement: 'dao cắt mâm dưới',
    lowerKnifeArrangementShort: 'dao cắt mâm dưới',
    upperNeedlePlate: 'Mâm trên',
    lowerNeedleCylinder: 'Mâm dưới',
    blank: 'Không có',
    blockRule: 'Đo đồ gá lắp',
    retractionBaseline: 'Quận Sinker. mặt sau',
    upperPlateNeedleWithdrawalKnob: 'Núm quay số',
    upperPlateNeedleWithdrawalDepth: 'Quận khâu quay số.',
    upperPlateHalfNeedleHeight: 'Quay số đan, gài cam.',
    upperPlateFlatNeedleHeight: 'Quay số miss cam dist.',
    lowerCylinderFlatNeedleHeight: 'Xi lanh bỏ cam dist.',
    lowerCylinderFlatNeedleDepth: 'Quận khâu xi lanh.',
    lowerCylinderNeedleWithdrawalKnob: 'Núm cân xi lanh',
    yarnTypeCode: 'Mã sợi',
    yarnTypeTensionN: 'Độ căng sợi (N)',
    cmPer100Needles: 'Chiều dài 100 kim bao nhieu',
    feedYarnLengthPerRevolution: 'Chiều dài mot vong may',
    aluminumPlateYarnFeedingDepthCm: 'Đường kinh dia soi bao nhieu',
    yarnFeedingAluminumPlateScale: 'dia soi may cai',
    newCustomerPackage: 'Kim lá',
    upperPlate: 'Mâm trên',
    lowerCylinder: 'Mâm dưới',
    yarnShort: 'Sợi',
    pleaseEnterProductName: 'Tên linh kiện',
    pleaseEnterProductNumber: 'Linh kiện số',
    quantity: 'Linh kiện bao nhiêu',
    damage: 'Hỏng',
    missing: 'Mất tích',
    wrong: 'Sai',
    pleaseEnterTitle: 'Nhập tiêu đề',
    pleaseEnterContent: 'Nhập nội dung',
    addQuestionItem: 'Thêm mục câu hỏi',
    questionProcessingRecord: 'Vấn đề sửa chữa',
    pleaseEnterQuestionDescription: 'Nhập mô tả vấn đề',
    traineeAndClient: 'Thực tập sinh / Khách hàng',
    trainer: 'huấn luyện viên',
    drawingFunction: 'Chức năng CAD',
    upperMachineProgram: 'Lập trình trên máy',
    UnravelingFunction: 'Phân tích vải',
    courseName: 'Tên khóa học',
    pleaseEnterCourseName: 'Nhập tên khóa học',
    imageName: 'Tên tệp mẫu',
    pleaseEnterImageName: 'Nhập tên tệp mẫu',
    confirmItem: 'Xác nhận',
    undone: 'chưa hoàn thiện',
    pleaseEnterInquire: 'Nhập tên khách hàng, tài liệu MU',
    machineUtilizationSurvey: 'Sử dụng máy móc',
    customerID: 'ID khách hàng',
    pleaseEnterCustomerID: 'Nhập ID khách hàng',
    pleaseSelect: 'Lựa chọn',
    pleaseEnterSkill: 'Nhập kỹ năng',
    pleaseEnterBuyer: 'Nhập người mua',
    pleaseEnterRemark: 'Nhập nhận xét',
    source: 'Nguồn ở đâu ra',
    selfInput: '自行輸入',
    textileEquipment: 'Máy kim tròn ngang',
    textileMachineBrand: 'Thương hiệu máy dệt kim',
    textileMachineType: 'Máy vi tính hai giàn',
    notSelected: 'Chưa chọn',
    select: 'Lựa chọn',
    brand: 'Thương hiệu',
    totalMachine: 'Bao nhiêu máy',
    openRate: 'Chạy bao nhiêu máy',
    dailyOutput: 'Sản lượng (tấn/ngày)',
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Vui lòng nhập nội dung điều chỉnh.',
    // alert
    editNotSave: 'Các chỉnh sửa chưa được lưu. Bạn có chắc chắn thoát ra không?',
    deleteConfirm: 'Bạn có chắc chắn muốn xóa không?',
    confirmClearSignature: 'Bạn có chắc chắn xóa dữ liệu liên quan đến chữ ký không?',
    confirmWriteData: 'Bạn có chắc chắn ghi dữ liệu vào không?',
    confirmCopyToSalesOrder: 'Bạn có chắc chắn sao chép dữ liệu vào báo cáo dịch vụ này không?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'Xóa thành công.',
    clearSuccess: 'Loại bỏ thành công.',
    copySuccess: 'Sao chép thành công.',
    selectWorker: 'Vui lòng chọn một kỹ thuật viên.',
    selectProblem: 'Vui lòng chọn mục câu hỏi.',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Chọn ngày',
    yarnTensionN: 'Độ căng sợi (N)',
    category: 'Phân loại',
    kind: 'Loại gì',
    // pleaseSelectType: 'Lựa chọn đối tượng',
    dateInOutError: 'Ngày kết thúc dịch vụ phải luôn bằng hoặc muộn hơn ngày bắt đầu dịch vụ.',
    yarnFeedingTeethOrDisc: 'Bánh răng/ròng rọc chất lượng',
    changed: 'đã thay đủ',
    pleaseSelectSparePartsStatus: 'Vui lòng chọn trạng thái phụ kiện.',
    pleaseEnterDuration: 'Vui lòng nhập thời gian phục vụ',

    // API語系
    saveComplete: 'Lưu thành công',
    needOnline: 'Need Online.',
    addComplete: 'Thêm thành công',
    reportCreator: 'Người tạo báo cáo',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: 'Synchronize Fail.',
    synchronizeSuccess: 'Đồng bộ hóa thành công.',
    downloadFail: 'Download Fail.',
    downloadSuccess: 'Tải xuống thành công.',
    synchronizeSelect: 'Đồng bộ hóa Chọn',
    onlySynchronizeOffData: 'Tải dữ liệu trực tuyến',
    synchronizeData: 'Đồng bộ hóa dữ liệu ngoại tuyến',
    synchronizeImage: 'Đồng bộ hóa hình ảnh',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Tải xuống dữ liệu ngoại tuyến',
    downloadOfflineImage: 'Tải xuống hình ảnh ngoại tuyến',
    synchronizing: 'Đang đồng bộ hóa, vui lòng đợi. Không đóng màn hình ứng dụng.',
    downloading: 'Đang tải xuống, vui lòng đợi. Không đóng màn hình ứng dụng.',
    confirmDownload: 'Bạn có xác nhận việc tải xuống không?',
    confirmSynchronization: 'Bạn có xác nhận việc đồng bộ hóa không?',
    overwriteOffline : 'Quá trình tải xuống sẽ ghi đè lên dữ liệu ngoại tuyến hiện tại.',
    synchronizationOnline: 'Quá trình đồng bộ hóa sẽ đồng bộ hóa dữ liệu liên quan trực tuyến.',
    uploadFail: 'Upload failed.',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Sắp xếp theo thứ tự',
    sortByType: 'Sắp xếp theo loại',
    reportDownload: 'dữ liệu đã tải về',
    selectServiceReport: 'Chọn Báo cáo Dịch vụ',
    enterServiceReportOrMachine: '“Nhập số báo cáo dịch vụ hoặc số máy',
    selectAll: 'Chọn tất cả',

    downloadHint:null
}
